module.exports = __webpack_public_path__ + "img/marketing-support.3a0f7aa9.jpg";